import { render, staticRenderFns } from "./HistoryMain.vue?vue&type=template&id=2b2a3adb&scoped=true&"
import script from "./HistoryMain.vue?vue&type=script&lang=js&"
export * from "./HistoryMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a3adb",
  null
  
)

export default component.exports